import type { OPCTermDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import AdjustDeductible from './AdjustDeductible';

const AdjustUvpContentSum = ({
    termInfo,
    updateTermValue,
    isAdjustableDataValid
}: {
    termInfo: OPCTermDTO;
    updateTermValue: (termValue: number, publicId?: string) => void;
    isAdjustableDataValid: boolean;
}): React.JSX.Element => {
    return (
        <AdjustDeductible
            termInfo={termInfo}
            updateTermValue={updateTermValue}
            isAdjustableDataValid={isAdjustableDataValid}
            overrideSubHeader="DSS-COVERABLE-DETAILS-ADAPT-SUM-SUBHEADER"
        />
    );
};

export default AdjustUvpContentSum;
